module.exports = "https://bce.bdstatic.com/video-meeting/zh-cn/assert/empty.25d7aa68.png";